// extracted by mini-css-extract-plugin
export default {"title":"styles_title__5JR67","groupContainer":"styles_groupContainer__WKKdx","cardContainer":"styles_cardContainer__WGWbi"};